var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/_isarray@2.0.4@isarray/index.js
// module id = 286
// module chunks = 0